/**
 * FakeIntersectionObserver
 *
 * Lies to browsers that do not support interaction observer.
 * Just does passthrough of props and says elements are visible.
 *
 * This class is aimed at implementation only inside <LazyRender />.
 * Correct behavior outside of the intented is not guaranteed.
 */
export class FakeIntersectionObserver {
    constructor(callback, options) {
        let t = options.threshold && Array.isArray(options.threshold) ?
            options.threshold :
            [options.threshold || .01];
        this.faked = true;
        this.thresholds = t;
        this.callback = callback;
        // tslint:disable-next-line
        this.root = options.root || null;
        this.rootMargin = options.rootMargin || "";
    }
    disconnect() { }
    observe(target) {
        this.callback(this.takeRecords(), {});
    }
    /* tslint:disable */
    takeRecords() {
        return [{
                isIntersecting: true,
                target: null
            }];
    }
    unobserve(target) { }
}
//# sourceMappingURL=FakeIntersectionObserver.js.map